module.exports = __webpack_public_path__ + "img/arrow-down.eccf8b08.svg";